export default "__VITE_ASSET__b89b5f4f__"